"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationSmsCodeForm = ConfirmationSmsCodeForm;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _InputField = require("../InputField");
var _Link = require("../Link");
var _CountdownTimer = require("../CountdownTimer");
var _FormFieldHelper = require("../FormFieldHelper");
var _FieldGroupLayout = require("../FieldGroupLayout");
var _keyCodes = require("../../types/keyCodes");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ConfirmationSmsCodeForm(_ref) {
  let {
    isSubmitting,
    handleSubmit,
    submitButtonText,
    code,
    codeRef,
    onCodeChange,
    codeError,
    isCodeInvalid,
    lastResendTime,
    resendAvailable,
    resendTimeout,
    onResend,
    onResendTimeoutExpired,
    buttons,
    isTemporarilyBlocked
  } = _ref;
  const handleResendCode = React.useCallback(e => {
    e.preventDefault();
    if (onResend) {
      onResend(e);
    }
  }, [onResend]);
  const handlePreventSubmit = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleSubmitOnEnter = React.useCallback(e => {
    if (e.keyCode === _keyCodes.EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(_FieldGroupLayout.FormFieldGroupLayout, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_InputField.InputField, {
      "data-name": "CodeInput",
      autoComplete: "one-time-code",
      autoFocus: true,
      name: "code",
      ref: codeRef,
      value: code,
      onKeyDown: handleSubmitOnEnter,
      onChange: onCodeChange,
      disabled: isSubmitting || isTemporarilyBlocked,
      invalid: isCodeInvalid,
      errorMessage: codeError,
      placeholder: "\u041A\u043E\u0434"
    }), !isTemporarilyBlocked && lastResendTime && resendTimeout ? /*#__PURE__*/React.createElement(_FormFieldHelper.FormFieldHelper, {
      alignment: _FormFieldHelper.EAlignment.Left,
      marginBottom: true
    }, /*#__PURE__*/React.createElement(_Link.Link, {
      href: "#",
      onClick: handleResendCode,
      disabled: !resendAvailable || isSubmitting
    }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E", !resendAvailable && /*#__PURE__*/React.createElement(_CountdownTimer.CountdownTimer, {
      fromTimestamp: lastResendTime,
      timeout: resendTimeout,
      onTimeoutExpired: onResendTimeoutExpired
    }, _ref2 => {
      let {
        timeLeft
      } = _ref2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, " \u0447\u0435\u0440\u0435\u0437 ", timeLeft, " \u0441\u0435\u043A.");
    }))) : null),
    buttons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "ConfirmCodeBtn",
      theme: "fill_primary",
      fullWidth: true,
      onClick: handleSubmit,
      loading: isSubmitting,
      disabled: isSubmitting || isTemporarilyBlocked
    }, submitButtonText), buttons)
  }));
}